import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { NoResponseReasonService } from './no-response-reason.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-no-response-reason',
  templateUrl: './no-response-reason.component.html',
  styleUrls: ['./no-response-reason.component.scss']
})
export class NoResponseReasonComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'reason', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  noResponseForm: FormGroup;
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private noResponseService: NoResponseReasonService) {
    this.noResponseForm = this.fb.group({
      reason: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
  }

  get f() { return this.noResponseForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.noResponseForm.patchValue({
      reason: object.reason,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true
    if (this.noResponseForm.valid) {
      const reasonData = this.noResponseForm.value;
      let obj = {
        "reason": reasonData.reason,
        "status": parseInt(reasonData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.noResponseService.noResponseReasonCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("No Response reason created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.noResponseForm.valid) {
      const reasonData = this.noResponseForm.value;
      let obj = {
        "reason": reasonData.reason,
        "status": parseInt(reasonData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.noResponseService.noResponseReasonCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("No Response reason updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.noResponseForm.patchValue({
      reason: '',
      status: ''
    });
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.noResponseService.noResponseReasonCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }else{
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

   public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const reason = data.reason.toLowerCase().includes(filter);
      return reason;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
